// main js file
import 'bootstrap';
import '../scripts/nav';
import 'magnific-popup';

function scrollToElement(selector) {
  var scrollEvents = 'scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove';
  var $page = jQuery('html, body');
  // stop animation on scroll input from user
  $page.on(scrollEvents, function(){
    $page.stop();
  });
  $page.animate({
    scrollTop: jQuery(selector).offset().top,
  }, 1000).promise()
    .then(function() {
    $page.off(scrollEvents);
  });
}

(function($) {
  $('.cy-more-content').on('click', function() {
    scrollToElement('main.main');
  });
  // for gallery popups
  $('.gallery').magnificPopup({
    delegate: '.gallery-item',
    type: 'image',
    showCloseBtn: true,
    fixedContentPos: true,
    callbacks: {
      elementParse: function(item) {
        item.src = $(item.el).find('img').attr('src');
      },
    },
    tLoading: 'Loading image #%curr%...',
    mainClass: 'gallery__mfp',
    gallery: {
      enabled: true,
      arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>', // markup of an arrow button
      tPrev: 'Previous (Left arrow key)', // title for left button
      tNext: 'Next (Right arrow key)', // title for right button
      tCounter: '<span class="mfp-counter">%curr% of %total%</span>',
      navigateByImgClick: true,
      preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
    },
    image: {
      cursor: null,
      tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
      titleSrc: function(item) {
        return $(item.el).find('figcaption').text();
      },
    }
  });
})(jQuery);


